/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_1Inputs */



/**
* | output |
* | --- |
* | "Up to 3 users included, more for $10/month each***" |
*
* @param {Signup_Feature_Pro_1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_1 = /** @type {((inputs?: Signup_Feature_Pro_1Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_1Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Up to 3 users included, more for $10/month each***")
	if (locale === "de") return /** @type {LocalizedString} */ ("Up to 3 users included, more for $10/month each***")
	if (locale === "it") return /** @type {LocalizedString} */ ("Up to 3 users included, more for $10/month each***")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Up to 3 users included, more for $10/month each***")
	if (locale === "es") return /** @type {LocalizedString} */ ("Up to 3 users included, more for $10/month each***")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Up to 3 users included, more for $10/month each***")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Up to 3 users included, more for $10/month each***")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Up to 3 users included, more for $10/month each***")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Up to 3 users included, more for $10/month each***")
	return /** @type {LocalizedString} */ ("Up to 3 users included, more for $10/month each***")
});